document.documentElement.classList.remove('no-js');

class TeaDrawer extends HTMLElement {
  connectedCallback() {
    this.trigger = document.querySelector(`[aria-controls="${this.id}"]`);
    this.closeButton = this.querySelector('[data-drawer-close]');
    this.trigger?.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
    });
  }

  open() {
    this.setAttribute('open', '');
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');
    this.closeButton?.focus();
  }

  close() {
    this.removeAttribute('open');
    this.trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    this.trigger?.focus();
  }
}

customElements.define('tea-drawer', TeaDrawer);

document.querySelectorAll('[data-nav-group]').forEach((group) => {
  group.addEventListener('toggle', () => {
    if (!group.open) return;
    const scope = group.closest('nav');
    scope?.querySelectorAll('[data-nav-group][open]').forEach((other) => {
      if (other !== group) other.removeAttribute('open');
    });
  });
});

document.querySelectorAll('[data-quantity]').forEach((control) => {
  const input = control.querySelector('input[type="number"]');
  control.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.quantityButton === 'increase' ? 1 : -1;
      const minimum = Number(input.min || 0);
      input.value = Math.max(minimum, Number(input.value || minimum) + direction);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('select[name="id"]');
  const product = form.closest('.main-product');
  const price = product?.querySelector('[data-live-price]');
  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    const mediaId = option?.dataset.mediaId;
    const media = mediaId ? product?.querySelector(`[data-product-media-id="${CSS.escape(mediaId)}"]`) : null;
    media?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
});
